import React from "react";
import StatusBadge from "../../UI/statusBadge";
import IndexLineChart from "./linechart";
import QuickStats from "./quickstats";
import AchievementsCard from "./achievements";

const CompanyInfo = ({ name, phone, email, is_active, avg_rate, address ,quick_stats ,  achievements,
                delivery_chart }) => {
  const companyDetails = [
    { title: "الإسم", value: name },
    { title: "   رقم الجوال", value: phone },

    { title: "الإيميل", value: email },
    { title: "العنوان", value: address },
    { title: "الحالة", value: "" },

    { title: " التقييم", value: `${avg_rate} ⭐` },
  ];

  return (
    <div className="row">
      <div className="col-md-6">
        <div className="card rounded-4 shadow-sm">
          <div className="card-body">
            <h5 className="fw-bold">المعلومات العامة</h5>
            <ul className="two-columns">
              {companyDetails.map((item, index) => (
                <li key={index}>
                  <h4 className="font14 font700">{item.title}</h4>
                  {item.title === "الحالة" ? (
                    <StatusBadge status={is_active ? "active" : ""} />
                  ) : (
                    <p>{item.value}</p>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="col-md-6">
        <QuickStats  quick_stats={quick_stats}/>
      </div>
      <div className="col-md-6">
        <IndexLineChart delivery_chart={delivery_chart}/>
      </div>
      <div className="col-md-6">
        <AchievementsCard achievements={achievements} />
      </div>
    </div>
  );
};

export default CompanyInfo;
